import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

import { IROH_SERVICES_API_PREFIX } from "@/api/domain"
import type { ApiKeyInfo, Pagination, ProjectIdParam, Uuid } from "@/types"

type CreateKeyRequestParams = {
  name: string
}

// Define a service using a base URL and expected endpoints
export const apiKeysApi = createApi({
  reducerPath: "api-keys",
  baseQuery: fetchBaseQuery({
    baseUrl: `${IROH_SERVICES_API_PREFIX}api-keys`,
    mode: "cors",
    credentials: "include",
  }),
  endpoints: (build) => ({
    // list the type of supported protocols
    apiKeysGet: build.query<ApiKeyInfo[], Pagination & ProjectIdParam>({
      query: ({ project_id, limit, offset }) => ({
        url: `${project_id}?offset=${offset}&limit=${limit}`,
      }),
    }),
    apiKeysPost: build.mutation<
      ApiKeyInfo,
      ProjectIdParam & CreateKeyRequestParams
    >({
      query: (body) => ({
        url: body.project_id,
        method: "POST",
        body,
      }),
    }),
    apiKeysDelete: build.mutation<void, ProjectIdParam & { key_id: Uuid }>({
      query: ({ project_id, key_id }) => ({
        method: "DELETE",
        url: `${project_id}/${key_id}`,
      }),
    }),
  }),
})

export const {
  useApiKeysGetQuery,
  useApiKeysPostMutation,
  useApiKeysDeleteMutation,
} = apiKeysApi
